import { Button, ButtonProps, CircularProgress } from '@mui/material'
import { ReactNode } from 'react'

interface Props extends ButtonProps {
    text?: string
    className?: string
    children?: ReactNode
    secondary?: boolean
    loading?: boolean
    disabled?: boolean
}
const CustomButton = ({
    text,
    className,
    children,
    secondary = false,
    disableElevation = false,
    loading = false,
    disabled = false,
    ...restOfProps
}: Props) => {
    const disable = loading || disabled
    return (
        <Button
            variant="contained"
            className={`normal-case ${disableElevation ? 'shadow-none' : 'shadow-[2px_2px_2px_0px_rgba(38,_44,_71,_0.1)]'} hover:bg-primary hover:text-white disabled:bg-disabled -:px-4 ${secondary ? 'bg-optional text-secondary' : '-:bg-secondary'} ${className}`}
            disabled={disable}
            {...restOfProps}
        >
            {loading ? (
                <CircularProgress
                    className="text-primary"
                    size={24}
                />
            ) : (
                <>
                    {text}
                    {children}
                </>
            )}
        </Button>
    )
}

export default CustomButton
